import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getInsights, loadInsights } from './actions'
import App from '../common/app'
import EmailAdminInsight from './components/index'
let unsubscribe = function () { }

function render() {
    renderWithRoot(
        <App active="cart" {...getState()} {...appActions}>
            <EmailAdminInsight {...getState()} {...appActions} changeSearchQuery={getInsights} />
        </App>,
        document.querySelector('#app')
    )
}

export function enter(context, next) {
    unsubscribe = subscribe(render)
    loadInsights()
    render()
}

export function exit(context, next) {
    unsubscribe()
    next()
}
